import React from "react";
import { useHistory } from "react-router-dom";

import Leg from "ui/components/card/leg";

export const LegList = ({ data, manifestID, status, trucking, type }) => {
  const History = useHistory();

  return (
    <div className="pb-5 px-2 ">
      {data?.map((d, i) => (
        <Leg
          onClick={() =>
            status === "started" &&
            History.push(`/leg/${d?.id}`, {
              manifest_id: manifestID,
              is_trucking: trucking,
              manifest_type: type,
            })
          }
          key={i}
          num={i + 1}
          location={d?.location}
          type={d?.type}
          status={d?.status}
        />
      ))}
    </div>
  );
};
